// sentry
import './instrument';

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/index.css';

import { Provider as ReduxProvider } from 'react-redux';

// localization
import './i18n';
import { StrictMode } from 'react';
import { AuthProvider } from 'react-oidc-context';
import oidcConfig from '@/oidc-client.config.ts';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '@/redux/store/index.ts';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <AuthProvider {...oidcConfig}>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App />
                </PersistGate>
            </ReduxProvider>
        </AuthProvider>
    </StrictMode>,
);
